// Copyright (c) 2020 Sagacity Solutions Inc. All right reserved.
'use strict';

import moment from 'moment-timezone'

function startOfDay(date, timezone) {
  let d = moment(date).format("YYYY-MM-DD");
  if (timezone === undefined) {
    timezone = moment.tz.guess();
  }
  return moment.tz(d, timezone);
}

function toDateTime (date, time, timezone) {
  let c = moment(date).format("YYYY-MM-DD");
  if (timezone === undefined) {
    timezone = moment.tz.guess();
  }
  let datestr = `${c} ${time.hh}:${time.mm} ${time.a}`;
  let d = moment.tz(datestr, "YYYY-MM-DD hh:mm a", timezone);
  return d;
}

function toTime (time) {
  return {
    hh: time.format('hh'),
    mm: time.format('mm'),
    a: time.format('a'),
  };
}

function diff(start, end) {
  let s = moment(start);
  let e = moment(end);
  return moment.duration(e.diff(s));
}

function generateEvent(date, time, timezone, range) {
  let intake = toDateTime(date, time, timezone).toDate();
  return {Intake: intake, Title: 'Dose intake', Range: range};
}

function generateSingleDose(date, time, timezone, range) {
  let evts = [];
  evts.push(generateEvent(date, time, timezone, range));
  return evts;
}

function generateCustomDoses(start, end, time, days, timezone, range) {
  let dur = diff(start, end);
  let evts = [];
  for (let i = 0; i <= dur.asDays(); i++) {
    let d = moment(start).add(i, 'd');
    days.forEach(function(wd) {
      if (d.format('ddd') == wd) {
        let e = generateEvent(d, time, timezone, range);
        evts.push(e);
      }
    });
  }
  return evts;
}


function generateRepeatedDoses(start, end, time, timezone, range) {
  let d = diff(start, end);
  let evts = [];
  for (let i = 0; i <= d.asDays(); i++) {
    let e = generateEvent(moment(start).add(i, 'd'), time, timezone, range);
    evts.push(e);
  }
  return evts 
}

export {
  toDateTime,
  toTime,
  startOfDay,
  generateCustomDoses,
  generateRepeatedDoses,
  generateSingleDose,
}
